module.exports = __webpack_public_path__ + "static/media/Delete.28b420e2.svg";